import Button from './button';

export default class Success extends Button {
  get buttonClass() {
    return 'ds-button--success';
  }
}
